import showCard from "./show_card/show_card";
import worksList from "@/components/view/work_groups/show/works_list/works_list";

export default {
  show_card: showCard,
  tech_map: worksList,
};
